// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".carbonara-user-icon {\n  width: 24px;\n  height: 24px;\n  margin: 4px;\n  padding: 8px 8px 6px;\n  font-size: 14px;\n  border-radius: 25px;\n  text-align: center;\n  color: white;\n}", ""]);
// Exports
module.exports = exports;
